export const getInitials = (name) => {
  const words = (name || '').trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return '';
  const first = words[0][0] || '';
  // For multi-word names use the first letter of the last word so the avatar
  // never shows more than two initials (e.g. "Jean Pierre Van Der Berg" -> "JB").
  const last = words.length > 1 ? words[words.length - 1][0] || '' : '';
  return (first + last).toUpperCase();
};
